var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid bg-grey"},[_c('SelectPracticeModal',{attrs:{"practice_user":_vm.practice_user,"email":_vm.email}}),_c('Loader',{attrs:{"is-visible":_vm.isLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }